import { ApiService } from '../../common'

export class AppPermissionsApi extends ApiService {}
